'use strict';

require('./enums/enums.js');
require('./models/suggestion.js');
require('./views/handle.js');
require('./views/invalidHandle.js');
require('./views/modal.js');
